module.exports = __webpack_public_path__ + "img/blue-plus.2fdf9b53.svg";